import { render, staticRenderFns } from "./FeedbackLab.vue?vue&type=template&id=9be40d3e&"
import script from "./FeedbackLab.vue?vue&type=script&lang=ts&"
export * from "./FeedbackLab.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackLab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports